import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogTitle, Typography } from '@mui/material';
import { closeBtn, deleteBtn, dialogActions, dialogTitle, paperProps, title } from './TemplateModals.sx';
import CloseIcon from 'app/components/Icons/CloseIcon';
import SuccessModal from 'app/components/SuccessModal';
import { useNavigate } from 'react-router-dom';

interface Props {
  open: boolean;
  close: Dispatch<SetStateAction<boolean>>;
  id?: any;
  deleteTemplate?: any;
  isEdit?: any;
  data?: any;
}

const DeleteTemplateModal = (props: Props) => {
  const { open, close, deleteTemplate, id, isEdit, data } = props;
  const [successModal, setSuccessModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (isEdit && data?.result === 'accepted') {
      navigate('/az/templates-page', { state: { deleted: true } });
    }
  }, [data]);

  return (
    <>
      <Dialog
        open={open}
        PaperProps={{
          sx: paperProps,
        }}
        onClose={() => close(false)}
      >
        <DialogTitle sx={{ ...dialogTitle, mb: '48px' }}>
          <Typography sx={title}>Şablonu silmək istəyirsiniz?</Typography>
          {/*<Button*/}
          {/*  color={'tertiary'}*/}
          {/*  onClick={() => {*/}
          {/*    close(false);*/}
          {/*  }}*/}
          {/*  sx={closeBtn}*/}
          {/*>*/}
          {/*  <CloseIcon />*/}
          {/*</Button>*/}
        </DialogTitle>
        <DialogActions sx={dialogActions}>
          <Button
            sx={deleteBtn}
            onClick={() => {
              close(false);
              deleteTemplate({
                id,
                content_data: {
                  state: 'deleted',
                },
              });
              // setSuccessModal(true);
            }}
          >
            Şablonu sil
          </Button>
          <Button
            color={'secondary'}
            sx={{ ml: '0 !important' }}
            onClick={() => {
              close(false);
            }}
          >
            İmtina
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DeleteTemplateModal;
